module.exports = __webpack_public_path__ + "img/checkmark-red.4ec77ec.svg";